import React, { useEffect } from "react";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import "./About.css";
const About = (props) => {
  const lang = useSelector((state) => state.reducer1.lang);
  const mode = useSelector((state) => state.reducer1.mode);

  useEffect(() => {
    if (props.goToAboutPhilosophy) {
      document
        .getElementById("philosophy")
        .scrollIntoView({ behavior: "smooth" });
    } else if (props.goToAboutInfo) {
      document.getElementById("info").scrollIntoView({ behavior: "smooth" });
    } else if (props.goToAboutPartners) {
      document
        .getElementById("partners")
        .scrollIntoView({ behavior: "smooth" });
    }
  }, [props.goToAboutPhilosophy, props.goToAboutInfo, props.goToAboutPartners]);

  // useEffect(()=>{
  //   if(props.goToAboutInfo){
  //     document.getElementById('info').scrollIntoView({ behavior: 'smooth' });
  //   }

  // },[props.goToAboutInfo])

  // useEffect(()=>{
  //   if(props.goToAboutPartners){
  //     document.getElementById('partners').scrollIntoView({ behavior: 'smooth' });
  //   }

  // },[props.goToAboutPartners])

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        zIndex: "1001",
        width: "100vw",
        height: "100vh",
        overflowX: "hidden",
        overflowY: "scroll",
        // border: "5px solid red",
      }}
    >
      <nav style={{ display: "flex"}}>
        <div style={{ display: "grid", placeItems: "center" }}>
          {mode == "day" ? (
            <img src="/img/logo-b.png" alt="" />
          ) : (
            <img src="/img/logo-w.png" alt="" />
          )}
          {lang === "en" ? (
            <p
              className="klee-one-regular"
              style={{
                color: mode == "day" ? "black" : "white",
                fontSize: ".8rem",
                position: "relative",
                // top: "-13em"
              }}
            >
              - Make the Region -
            </p>
          ) : (
            <p
              className="klee-one-regular"
              style={{ color: "black", fontSize: ".8rem" }}
            >
              - 地域をより良い明日に -
            </p>
          )}
        </div>

        <div
          className="cancelBtn"
          style={{ color: "white" }}
          onClick={() => {
            // setTimeout(() => {
            props.cancelAbout();
            // }, 400);
            document.getElementById("main").className = "animateAboutClose";
          }}
        >
          <MdCancel />
        </div>
      </nav>

      <main style={{ marginTop: "5rem" }}>
        <div
          className="aboutCard"
          style={{
            backgroundColor: "white",
            borderRadius: "12px",
            // border:"2px solid yellow"
          }}
        >
          {lang === "en" ? (
            <h2
              className="luckiest-guy-regular"
              style={{
                cursor: "auto",
                left: "-8px",
                position: "relative",
                color: "#192F83",
              }}
            >
              ABOUT
            </h2>
          ) : (
            <h2
              className="luckiest-guy-regular"
              style={{
                fontSize: "4rem",
                cursor: "auto",
                marginBottom: "1.7rem",
              }}
            >
              について
            </h2>
          )}

          {lang === "en" ? (
            <h4
              className="interFont"
              style={{
                color: "#828282",
                left: "0px",
                top: "-0.4em",
                position: "relative",
              }}
            >
              A challenge starting from Gotemba to promote the attraction of the
              region to the world
            </h4>
          ) : (
            <h4
              className="interFont"
              style={{ color: "#828282", marginBottom: "2rem" }}
            >
              地域の魅力を世界に発信する、御殿場から始まる挑戦
            </h4>
          )}

          {lang === "en" ? (
            <p
              className="interFont"
              style={{
                color: "#192F83",
                left: "-1px",
                top: "-0.3em",
                position: "relative",
              }}
            >
              Regionport is to fulfill its role as a "regional port" and
              maximize the attraction of the region. We promote various events
              and projects to revitalize the region by utilizing local culture
              and natural resources.
            </p>
          ) : (
            <p
              className="interFont"
              style={{ color: "#192F83", marginBottom: "1rem" }}
            >
              Regionportは、「地域の港」としての役割を果たし、地域の魅力を最大限に引き出すことを使命としています。私たちは、地元の文化や自然資源を活用し、地域の活性化を図るための様々なイベントやプロジェクトを推進しています。
            </p>
          )}
        </div>

        <div
          style={{
            width: "100%",
            height: "200px",
            backgroundColor: "red",

            background:
              "linear-gradient(to bottom ,rgba(151, 152, 153,0), rgba(46,169,255,255))",
          }}
        ></div>

        <div
          className="aboutMain"
          style={{
            backgroundColor: "rgba(46,169,255,255)",
          }}
        >
          <h2
            className="luckiest-guy-regular"
            style={{
              color: "white",
            }}
            id="philosophy"
          >
            Philosophy
          </h2>

          <h3
            className="subheaders"
            style={{
              color: "white",
              marginTop: "1em",
              marginBottom: "0.1em",
            }}
          >
            Vision
          </h3>

          <p
            className="interFont"
            style={{
              marginBottom: "4rem",
              color: "white",
            }}
          >
            To promote the charm of the region to the world and contribute to
            the development of the local community.
          </p>

          <h3
            className="subheaders"
            style={{
              color: "white",
              marginBottom: "0.1em",
            }}
          >
            Mission Statement
          </h3>

          <p
            className="interFont"
            style={{
              // paddingBottom: "4rem",
              color: "white",
            }}
          >
            We utilize local culture and natural resources to promote events and
            projects that maximize the charm of the region.
            <br /> We aim to continue growing together with the local community
            and are active with pride in the region.
          </p>

          <h2
            className="luckiest-guy-regular"
            style={{
              color: "white",
              marginTop: "15rem",
            }}
            id="info"
          >
            Corporate Info
          </h2>

          <p
            className="interFont"
            style={{
              position: "relative",
              // left: "59%",
              paddingBottom: "3rem",
              color: "white",
              lineHeight: "2em",
            }}
          >
            Company name: Regionport LLC
            <br />
            Address: 1855 Higashi Tanaka, Gotemba City, Shizuoka Prefecture
            <br />
            Telephone: 0550-77-5276
            <br />
            Established: December 1, 2017 (2022/10: 6th term)
          </p>

          <h2
            className="luckiest-guy-regular"
            style={{
              color: "white",
              marginTop: "15rem",
            }}
            id="partners"
          >
            Partners
          </h2>
          <p
            className="interFont"
            style={{
              lineHeight: "1.4em",
              color: "white",
              paddingBottom: "10rem",
            }}
          >
            Major clients Gotemba City / Susono City / Fuji City / Gotemba City
            Tourism Association / Live Exam Co., Ltd.
            <br />
            / R-Beads Co., Ltd. / Goldwin Co., Ltd. / Japan Gore LLC (Co., Ltd.)
            )JM/ Kirin Distillery Co., Ltd./ Iwatani Primus Co.,
            <br />
            Ltd./ ELDNACS Inc./ Inter Proto Motors Co., Ltd./ Yamatoya Watch
            Shop Co., Ltd./ Kanagawa Toyota Co.,
            <br />
            Ltd. / Japan Footgolf Association/ FM Gotemba/ LOVE FOR NIPPON/
            Arshan Kogyo Co.,
            <br />
            Ltd./ Virtus Sliding Club / Asahi Kasei Advance Co., Ltd./ Jofka
            Co., Ltd./ Arcla Circus Executive Committee/ Instate Co.,
            <br />
            Ltd./ KDDI Co., Ltd./ Fuji-Q Highland Co., Ltd./ Fujikyu Railway
            Co., Ltd./ Fuji-Q Travel Co., Ltd./ Fuji Speedway Co.,
            <br />
            Ltd./ Tsuboguchi Food Service Co., Ltd./ Fuji Architectural Design
            Office/ Suruga Research and Design Co.,
            <br />
            Ltd./ Rising Field Co., Ltd./Slow Hand Relations / Gotemba Gas Co.,
            Ltd. / IOV Co., Ltd. / SBS Promotion Co.,
            <br />
            Ltd. / TENSIX Co., Ltd. / Torch Relay Co., Ltd. / Sanji
            International Co., Ltd. / NPO Fuji Trail Runners Club / Nippon Koei
            Co.,
            <br />
            Ltd. / DeDee Co., Ltd. / Big Wing Co., Ltd. / Ikemitsu Enterprise
            Co., Ltd. / Watanabe Shoten Co., Ltd. / Dia Plus Co.,
            <br />
            Ltd. / Tower Records Co., Ltd. / Shibuya Television Co., Ltd. /
            SOTOE Co., Ltd. / 44&Co. (same) / AAP Co.,
            <br />
            Ltd. / Gimmick Co., Ltd. / Fit Corporation Co., Ltd. / Yebisu (same)
            etc...
          </p>

          {/* <h2
            className="luckiest-guy-regular"
            style={{
              fontSize: "5rem",
              color: "white",
              position: "relative",
              left: "61%",
              margin: "12rem 0 0rem 0",
            }}
          >
           Profile
          </h2>

          <p
            className="interFont"
            style={{
              position: "relative",
              left: "59%",
              marginBottom: "20.5rem",
              fontFamily: 'cursive',
              fontSize: '1em',
              color: "white"
            }}
          >
            Company name: Regionport LLC<br/>
            Address: 1855 Higashi Tanaka, Gotemba City, Shizuoka Prefecture<br/>
            Telephone: 0550-77-5276<br/>
            Established: December 1, 2017 (2022/10: 6th term)
          </p>

          <h3 className="subheaders"
          style={{
            fontSize: "1.2rem",
            color: "white",
            marginLeft: "57.8rem",
            marginTop: "-16em" 
          }}
          >Business content</h3>

<p
            className="interFont"
            style={{
              position: "relative",
              left: "59%",
              marginBottom: "20rem",
              fontFamily: 'cursive',
              fontSize: '1em',
              color: "white",
              marginTop: "1em"
            }}
          >
            Organizing and managing events that are rooted in the local community.<br/>
            Producing new things, things, and people together with the local community.<br/>
            Supporting the development of young entrepreneurs and UI-turn workers.<br/>
            Signboard printing.<br/>
            
              Banks: Shizuoka Bank / Suruga Bank / Numazu Shinkin Bank
          </p>




          <h2
            className="luckiest-guy-regular"
            style={{
              fontSize: "5rem",
              color: "white",
              margin: "12rem 0 0rem 3rem",
            }}
          >
            Partners
          </h2>
          <p
            className="interFont"
            style={{
              marginLeft: "2.6rem",
              marginBottom: "20rem",
              fontFamily: 'cursive',
              fontSize: '1em',
              color: "white",
            }}
          >
           Major clients
           Gotemba City / Susono City / Fuji City / Gotemba City Tourism Association / Live Exam Co., Ltd.<br/>
           / R-Beads Co., Ltd. / Goldwin Co., Ltd. / Japan Gore LLC
           (Co., Ltd.) )JM/ Kirin Distillery Co., Ltd./ Iwatani Primus Co.,<br/>
           Ltd./ ELDNACS Inc./ Inter Proto Motors Co., Ltd./ Yamatoya Watch Shop Co., Ltd./ Kanagawa Toyota Co.,<br/>
           Ltd.  / Japan Footgolf Association/ FM Gotemba/ LOVE FOR NIPPON/ Arshan Kogyo Co.,<br/>
           Ltd./ Virtus Sliding Club / Asahi Kasei Advance Co., Ltd./ Jofka Co., Ltd./ Arcla Circus Executive Committee/ Instate Co.,<br/>
           Ltd./ KDDI Co., Ltd./ Fuji-Q Highland Co., Ltd./ Fujikyu Railway Co., Ltd./ Fuji-Q Travel Co., Ltd./ Fuji Speedway Co.,<br/>
           Ltd./ Tsuboguchi Food Service Co., Ltd./ Fuji Architectural Design Office/ Suruga Research and Design Co.,<br/>
           Ltd./ Rising Field Co., Ltd./Slow Hand Relations / Gotemba Gas Co., Ltd. / IOV Co., Ltd. / SBS Promotion Co.,<br/>
           Ltd. / TENSIX Co., Ltd. / Torch Relay Co., Ltd. / Sanji International Co., Ltd. / NPO Fuji Trail Runners Club / Nippon Koei Co.,<br/>
           Ltd. / DeDee Co., Ltd. / Big Wing Co., Ltd. / Ikemitsu Enterprise Co., Ltd. / Watanabe Shoten Co., Ltd. / Dia Plus Co.,<br/>
           Ltd. / Tower Records Co., Ltd. / Shibuya Television Co., Ltd. / SOTOE Co., Ltd. / 44&Co. (same) / AAP Co.,<br/>
           Ltd. / Gimmick Co., Ltd. / Fit Corporation Co., Ltd. / Yebisu (same)
           etc...
          </p>

          <h2
            className="luckiest-guy-regular"
            style={{
              fontSize: "5rem",
              color: "white",
              position: "relative",
              left: "42%",
              margin: "12rem 0 0rem 0",
            }}
          >
            Cooperative projects
          </h2>
          <p
            className="interFont"
            style={{
              position: "relative",
              left: "41.5%",
              paddingBottom: "40rem",
              fontFamily: 'cursive',
              fontSize: '1em',
              color: "white",
            }}
          >
            2024: ALL Gotemba Sake Brewery Project<br/>
              (Images, text, and links attached)<br/><br/>
            2024: Grand Ferest Park concept using abandoned land for private use<br/>
              (Images, text, and links attached)<br/><br/>
          </p> */}
        </div>

        {/* <div style={{ marginLeft: "auto", marginRight: "2rem" }}>
          <img style={{ width: "600px",borderRadius:"10px"  }} src="/img/map.jpg" alt="" />
        </div> */}
      </main>
    </div>
  );
};

export default About;
